import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const Order_product_tab = ({ data }) => {
    return (
        <div className="description" style={{ overflow: 'scroll', height: '300px' }}>Products:
            {data == '' ? <div className="d-flex justify-content-center align-items-center"> <p className="description " style={{ opacity: '0.5' }}>No Products!</p></div> : data?.map((pd) => {

                return <Link to={`/admin/Total-Orders/Single-Order/ViewProduct/${pd.id}`} ><div key={pd.id} className="my-2 ">
                    <div className="d-flex justify-content-between shadow-lg border rounded p-2">
                        <div className="d-flex ">
                            <div style={{ height: '50px' }}>
                                <img src={pd.image} className="image-fluid" style={{ height: '100%', width: '100%' }} />
                            </div>
                            <div className="px-3">
                                <p className=" font-weight-bolder ">{pd.name}</p>

                                <div className="d-flex justify-content-between">

                                    <div className="d-flex justify-content-between " >
                                        <p className=" font-weight-bolder" style={{ color: '#1CACE3' }}>AED</p>
                                        <p className=' pl-2 '>{pd.price} x {pd.quantity}</p>
                                    </div>
                                    <div>
                                        <i className="tim-icons icon-cloud-download-93" />
                                    </div>
                                </div>




                            </div>
                        </div>

                        <p className='flex-end'>Total Amount : {pd.totalPrice} AED</p>
                    </div>
                </div>
                </Link>
            })}
        </div>
    )
}

export default Order_product_tab